import { useCfIdentity, useLogout } from "@civala/shared-ui"
import {
  ActionIcon,
  Avatar,
  Badge,
  Group,
  SegmentedControl,
  Text,
  Tooltip,
  useComputedColorScheme,
  useMantineColorScheme,
} from "@mantine/core"
import { IconLogout, IconMoon, IconSun } from "@tabler/icons-react"
import { useState } from "react"

/** Left-side topbar content for investor: syndicate badge + audience toggle. */
export function InvestorTopBarLeft() {
  const [viewMode, setViewMode] = useState("est")

  return (
    <>
      <Badge variant="light" size="sm">
        Syndicate I
      </Badge>
      <SegmentedControl
        size="xs"
        value={viewMode}
        onChange={setViewMode}
        data={[
          { label: "EST Admin", value: "est" },
          { label: "LP View", value: "lp" },
        ]}
      />
    </>
  )
}

/** Right-side topbar content for investor: theme toggle, user avatar, sign-out. */
export function InvestorTopBarRight() {
  const { setColorScheme } = useMantineColorScheme()
  const computedColorScheme = useComputedColorScheme("light")
  const isDark = computedColorScheme === "dark"
  const identity = useCfIdentity()
  const logout = useLogout()

  return (
    <>
      <Tooltip label={isDark ? "Light mode" : "Dark mode"}>
        <ActionIcon variant="subtle" color="gray" size="md" onClick={() => setColorScheme(isDark ? "light" : "dark")}>
          {isDark ? <IconSun size={18} stroke={1.5} /> : <IconMoon size={18} stroke={1.5} />}
        </ActionIcon>
      </Tooltip>
      <Tooltip label={identity.name || "User"}>
        <Group gap="xs" style={{ cursor: "default" }}>
          <Avatar size="sm" radius="xl" color="pitchNavy">
            {identity.initials}
          </Avatar>
          <Text size="xs" c="dimmed">
            {identity.givenName || identity.name}
          </Text>
        </Group>
      </Tooltip>
      <Tooltip label="Sign out">
        <ActionIcon variant="subtle" color="gray" size="md" onClick={logout}>
          <IconLogout size={18} stroke={1.5} />
        </ActionIcon>
      </Tooltip>
    </>
  )
}
